import SidePanel from "layouts/SidePanel";
import React, { useEffect, useState } from "react";
import ProjectsTableSection from "./components/ProjectsTableSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchRfqProjects } from "actions/rfqActions";
import ProjectFormDrawer from "./components/ProjectFormDrawer";

const ProjectSection = () => {
  const dispatch = useDispatch();
  const [showCreateProjectForm, setShowCreateProjectForm] = useState(false);
  const auth = useSelector((state) => state.auth);

  const user = auth?.user;
  const entityId = user?.userEntity?.entityId;

  const handleOpenCreateProjectForm = () => {
    setShowCreateProjectForm(true);
  };

  useEffect(() => {
    if (entityId) {
      dispatch(fetchRfqProjects(entityId));
    }
  }, [dispatch, entityId]);

  return (
    <SidePanel>
      <div className="flex h-screen w-full flex-col overflow-hidden bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">
        <div className="bg-white sticky top-0 z-10 shadow-md p-4">
          <h1 className="text-base font-bold">Projects</h1>
        </div>
        <ProjectsTableSection onCreateProject={handleOpenCreateProjectForm} />
        <ProjectFormDrawer
          open={showCreateProjectForm}
          onClose={() => setShowCreateProjectForm(false)}
        />
      </div>
    </SidePanel>
  );
};

export default ProjectSection;
